import React, { Component, PropTypes } from 'react';
import CSSModules from 'react-css-modules';
import Styles from './CookieBanner.css';

@CSSModules(Styles)
class CookieBanner extends Component {
  static propTypes = {
    message: PropTypes.string,
    buttonLabel: PropTypes.string,
    cookieName: PropTypes.string,
  };

  static defaultProps = {
    message: 'This website uses cookies to improve your experience.',
    buttonLabel: 'Got it',
    cookieName: 'IvyAysCookiesAccepted',
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
    this.dismiss = this.dismiss.bind(this);
  }

  componentDidMount() {
    this.setState({
      visible: !this.getCookie(this.props.cookieName)
    })
  }

  getCookie(name) {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='));
  }

  dismiss() {
    const expiry = new Date();
    expiry.setFullYear(expiry.getFullYear() + 1);
    document.cookie = `${this.props.cookieName}=true; expires=${expiry.toUTCString()}; path=/; SameSite=Lax`;
    this.setState({ visible: false });
  }

  render() {
    if (!this.state.visible) return null;

    return (
      <div styleName="cookie-banner">
        <p styleName="cookie-banner__message">
          {this.props.message}
        </p>
        <button
          styleName="cookie-banner__button"
          onClick={this.dismiss}
        >
          {this.props.buttonLabel}
        </button>
      </div>
    );
  }
}

export default CookieBanner;